/**
 * 平台: QQ webview
 * 通用能力:
 * 1.bridge mqqReady (qq)
 * 2.登录: None
 * 3.定位: mqqLocate
 * 4.订阅: None
 * 5.分享: None
 */
import { utils } from '@didi/webx-js-core';
import { sdkReady } from '../../loader';
import { storage } from '../../../storage';
const _qqSDK = '//open.mobile.qq.com/sdk/qqapi.wk.js?_bid=152';
// 文档：https://open.mobile.qq.com/api/common/index
/**
 * 手q webview bridgeReady
 * @param callback
 */
const mqqReady = (callback) => {
    sdkReady('mqq', _qqSDK, sdk => {
        callback(sdk);
    });
};
const mqqLocate = () => {
    return new Promise((resolve, reject) => {
        mqqReady(sdk => {
            if (sdk && sdk.sensor.getLocation) {
                sdk.sensor.getLocation({}, (retCode, lat, lng) => {
                    if (retCode === 0) {
                        /* 获取定位信息成功 存入缓存 */
                        storage.locationInfo = {
                            lat,
                            lng
                        };
                        let newRiskParams = Object.assign({}, storage.riskParams, { latitude: lat, longitude: lng });
                        utils.cleanEmptyKey(newRiskParams);
                        storage.riskParams = newRiskParams;
                        resolve({
                            lat,
                            lng
                        });
                    }
                    else {
                        storage.locationInfo = {};
                        let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined });
                        utils.cleanEmptyKey(newRiskParams);
                        storage.riskParams = newRiskParams;
                        reject(retCode);
                    }
                });
            }
            else {
                /* 获取定位信息失败 存入缓存 */
                storage.locationInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject('qqsdk加载异常');
            }
        });
    });
};
export { mqqReady, mqqLocate };
